import { BID_STATUS } from 'legacy/constants/bids'

import { type BidLoad, type Bid } from 'loads/domain/Bid'

export function getAwardedBid(activeBid: Nullable<Bid>, load?: Partial<BidLoad>): Bid | null {
  if (activeBid?.status !== BID_STATUS.AWARDED && activeBid?.status !== BID_STATUS.ACCEPTED)
    return null

  if (activeBid?.load?.uuid !== load?.uuid) return null

  return activeBid
}
